module.exports = __webpack_public_path__ + "assets/architecture.5fe09998.svg";